import React, { memo, SVGProps } from 'react'

export const ArrowUpSquare = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M7.09999 20.7H16.9C19 20.7 20.7 19 20.7 16.9V7.09999C20.7 4.99999 19 3.29999 16.9 3.29999L7.09999 3.29999C4.99999 3.29999 3.29999 4.99999 3.29999 7.09999L3.29999 16.9C3.29999 19 4.99999 20.7 7.09999 20.7ZM4.89999 7.09999C4.89999 5.88999 5.88999 4.89999 7.09999 4.89999L16.9 4.89999C18.11 4.89999 19.1 5.88999 19.1 7.09999L19.1 16.9C19.1 18.11 18.11 19.1 16.9 19.1L7.09999 19.1C5.88999 19.1 4.89999 18.11 4.89999 16.9L4.89999 7.09999Z"
      fill="currentColor"
    />
    <path
      d="M9.15999 13.77L12 10.93L14.84 13.77C15.15 14.08 15.66 14.08 15.97 13.77C16.28 13.46 16.28 12.95 15.97 12.64L12.56 9.22999C12.41 9.07999 12.21 8.99999 11.99 8.99999C11.77 8.99999 11.57 9.07999 11.42 9.22999L8.00999 12.64C7.69999 12.95 7.69999 13.46 8.00999 13.77C8.31999 14.08 8.82999 14.08 9.13999 13.77H9.15999Z"
      fill="currentColor"
    />
  </svg>
))
